module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('nav', {
    staticClass: "sidebar-nav"
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/'
    }
  }, [_c('i', {
    staticClass: "icon-speedometer"
  }), _vm._v("\n                    Dashboard\n                ")])], 1), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/usuarios'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                    Usuários\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/usuarios/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/usuarios',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/usuarios'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "icon-people"
  }), _vm._v("\n                    Clientes\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/clientes/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/clientes',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/clinicas'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marked-alt"
  }), _vm._v("\n                    Rede Credenciada\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/clinicas/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/clinicas',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/clinicas/importar',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v("\n                            Importar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/apolices'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-file-contract"
  }), _vm._v("\n                    Apólices\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/apolices',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['T', 'A']
      }),
      expression: "{ roles: ['T','A'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/categorias'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                    Categoria\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/categorias/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/categorias',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['T', 'A']
      }),
      expression: "{ roles: [ 'T','A'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/post'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-paste"
  }), _vm._v("\n                    Post\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/post/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/post',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/integradoras'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-satellite-dish"
  }), _vm._v("\n                    Integradoras\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/integradoras/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/integradoras',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/paises'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-globe"
  }), _vm._v("\n                    Países\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/paises/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/paises',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/operadoras'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-satellite"
  }), _vm._v("\n                    Operadoras\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/operadoras/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/operadoras',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/manuais-usuario'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-handshake"
  }), _vm._v("\n                    Manuais Usuário\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/manuais-usuario/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/manuais-usuario',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/central-atendimento'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-phone"
  }), _vm._v("\n                    Central Atendimento\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/central-atendimento/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/central-atendimento',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/paginas'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-mobile-alt"
  }), _vm._v("\n                    Páginas\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/paginas/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/paginas',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/menus'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-list"
  }), _vm._v("\n                    Menus\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/menus/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/menus',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "dw-authorized",
      rawName: "v-dw-authorized",
      value: ({
        roles: ['A', 'D']
      }),
      expression: "{ roles: ['A', 'D'] }"
    }],
    staticClass: "nav-item nav-dropdown",
    attrs: {
      "tag": "li",
      "to": {
        path: '/cadastros/cupons-desconto'
      },
      "disabled": ""
    }
  }, [_c('div', {
    staticClass: "nav-link nav-dropdown-toggle",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "fas fa-tag"
  }), _vm._v("\n                    Cupons Desconto\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-dropdown-items"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/cupons-desconto/novo',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), _vm._v("\n                            Criar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/cupons-desconto',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "icon-list"
  }), _vm._v("\n                            Listar\n                        ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/cadastros/cupons-desconto/importar',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v("\n                            Importar\n                        ")])], 1)])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed8ed862","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 900
// module chunks = 1